var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 2.68643 9.31355 0 6 0C2.68645 0 0 2.68643 0 6C0 9.31357 2.68645 12 6 12C9.31355 12 12 9.31357 12 6ZM9.12316 4.73077L6 8.48334L2.87681 4.73077H9.12316Z",
    fill: "#FF3D8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleDown);
export default __webpack_public_path__ + "static/media/icon-circle-down.a44820c0d5b453fdeff8ae17ade58159.svg";
export { ForwardRef as ReactComponent };